(function($){

    $.fn.slider = function(){

        var elem = $(this),
            viewLimit = 1;

        const init = function(){

            elem.slick({
                //centerMode: true,
                //centerPadding: '50px',
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 4500,
                infinite: true,
                arrows: false,
                dots: true,
                adaptiveHeight: false,
                dotsClass: 'slider__dots',
                customPaging: function (slider, i){

                    return '<span class="slider__dots__item"></span>';

                }
            });

        };

        init();

        return this;

    }

}(jQuery));